module.exports = __webpack_public_path__ + "img/logo-login.ce1205e7.webp";